<div id="map">

  <google-map 
    *ngIf="isMapReady"
    width="100%"
    [center]="center" 
    [zoom]="zoom" 
    (mapClick)="onMapClick($event)">

    <!-- Display all branch locations -->
    <ng-container *ngFor="let branch of branchLocations">
      <map-marker
        #marker="mapMarker"
        [position]="branch.position"
        [title]="branch.branch"
        (mapClick)="onMarkerClick(branch, marker)">
      </map-marker>
    </ng-container>

    <map-info-window #infoWindow *ngIf="currentLanguage === 'en'">
      <h6 style="margin-bottom: 20px; color: #FFB81C;">{{ selectedBranch?.branch }}</h6>
      <p style="color: #005EB8">{{ 'contact_us.Tel' | translate }}: {{ selectedBranch?.tel }}</p>
      <p style="margin-top: -10px; ">{{ 'contact_us.Address' | translate }}: {{ selectedBranch?.address }}</p>
    </map-info-window>

    <map-info-window #infoWindow *ngIf="currentLanguage === 'kh'">
      <h6 style="margin-bottom: 20px; color: #FFB81C">{{ selectedBranch?.branchKh }}</h6>
      <p style="color: #005EB8;">{{ 'contact_us.Tel' | translate }}: {{ selectedBranch?.tel }}</p>
      <p style="margin-top: -10px;">{{ 'contact_us.Address' | translate }}: {{ selectedBranch?.addressKh }}</p>
    </map-info-window>
  
  </google-map>

</div>


<div class="bottom-content-poster">
    <img src="images/customer_service/customer_service_1.jpg" alt="">
    <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
</div>
